/* eslint-disable */
import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  TextField,
  Autocomplete,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  Checkbox,
  Grid,
} from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import EmailIcon from '@mui/icons-material/Email';
import api from '../../utils/functions/api';
import { getStorage } from '../../utils/functions/localstorage';

import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import StorefrontIcon from '@mui/icons-material/Storefront';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';

const FinalConfirmationPopup = ({ open, onClose }) => (
  <Dialog
    open={open}
    onClose={onClose}
    PaperProps={{
      sx: {
        borderRadius: '15px',
        width: '400px',
      },
    }}
  >
    <DialogContent>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: 'bold',
          fontSize: '24px',
          marginTop: '20px',
        }}
      >
        <CheckCircleOutlineIcon
          sx={{ fontSize: 90, color: 'green', marginBottom: '10px' }}
        />
        บันทึกสำเร็จ !
      </Box>
    </DialogContent>
    <DialogActions sx={{ justifyContent: 'center' }}>
      <Button
        onClick={onClose}
        sx={{
          width: '100px',
          border: '1px solid',
          color: '#45A6F5',
          backgroundColor: 'transparent',
          '&:hover': {
            backgroundColor: '#E3F3FF',
          },
        }}
      >
        ปิด
      </Button>
    </DialogActions>
  </Dialog>
);

const EditAccountManagementAdminEEntry = ({
  open,
  onClose,
  data,
  merchant,
}) => {
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;
  const [showConfirmation, setShowConfirmation] = useState(false);
  const roleOptions = ['Admin', 'User'];

  const [account, setAccount] = useState({
    email: '',
    mkeys: [{ mkey: '' }],
    stores: [],
    role: '',
  });
  const [originalAccount, setOriginalAccount] = useState(account);
  const [errors, setErrors] = useState({
    email: '',
    mKeys: [],
    stores: '',
    role: '',
  });

  useEffect(() => {
    if (data) {
      const initialAccount = {
        email: data.email || '',
        mkeys: data.Company?.map((c) => ({ mkey: c.mkey })) || [{ mkey: '' }],
        stores:
          data.company_id?.map((id, index) => ({
            id,
            name: data.company_name[index],
          })) || [],
        role: data.role || '',
      };
      setAccount(initialAccount);
      setOriginalAccount(initialAccount);
    }
  }, [data]);

  const validateFields = () => {
    let formHasErrors = false;
    const newErrors = { email: '', mKeys: [], stores: '', role: '' };

    if (!account.email.trim()) {
      newErrors.email = 'กรุณากรอกอีเมลล์';
      formHasErrors = true;
    }

    if (!account.role) {
      newErrors.role = 'กรุณาเลือกหน้าที่';
      formHasErrors = true;
    }

    if (!account.stores.length) {
      newErrors.stores = 'กรุณาเลือกร้านค้า';
      formHasErrors = true;
    }

    setErrors(newErrors);
    return !formHasErrors;
  };

  const handleEdit = async () => {
    if (!validateFields()) return;

    try {
      const mkeyArray = account.mkeys.map((mkeyObj) => mkeyObj.mkey);
      const { data: response } = await api.put(
        `${process.env.REACT_APP_APIHOST}/eentry/users/${data.id}`,
        {
          id: data.id,
          email: account.email,
          role: account.role,
          company_ids: account.stores.map((s) => s.id),
        },
        {
          headers: { Authorization: getStorage('token') },
        },
      );

      if (response.status === 'success') {
        setShowConfirmation(true);
      }
    } catch (error) {
      console.error('Failed to edit user:', error);
      alert('เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง');
    }
  };

  const handleCloseConfirmation = () => {
    setShowConfirmation(false);
    window.location.reload();
  };

  const handleClose = () => {
    setAccount(originalAccount);
    onClose();
  };

  const handleAccountChange = (e) => {
    const { name, value } = e.target;
    setAccount((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{
          sx: {
            borderRadius: '15px',
            width: '100%',
            maxWidth: '550px',
          },
        }}
      >
        <DialogTitle>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              marginX: '10px',
              marginTop: '6px',
            }}
          >
            <span>แก้ไขบัญชี</span>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ px: 2, pt: 1 }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <EmailIcon sx={{ mr: 2 }} />
                  <TextField
                    fullWidth
                    label="อีเมลล์"
                    variant="outlined"
                    size="small"
                    name="email"
                    value={account.email}
                    onChange={handleAccountChange}
                    error={!!errors.email}
                    helperText={errors.email}
                  />
                </Box>
              </Grid>

              <Grid item xs={12}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <StorefrontIcon sx={{ mr: 2 }} />
                  <Autocomplete
                    multiple
                    fullWidth
                    options={merchant}
                    disableCloseOnSelect
                    getOptionLabel={(option) => option.name}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    value={account.stores}
                    onChange={(e, newValue) =>
                      setAccount((prev) => ({ ...prev, stores: newValue }))
                    }
                    renderOption={(props, option, { selected }) => (
                      <li {...props}>
                        <Checkbox
                          icon={icon}
                          checkedIcon={checkedIcon}
                          style={{ marginRight: 8 }}
                          checked={selected}
                        />
                        {option.name}
                      </li>
                    )}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="ร้านค้า"
                        placeholder="เลือกหรือพิมพ์ค้นหา"
                        size="small"
                        error={!!errors.stores}
                        helperText={errors.stores}
                      />
                    )}
                    filterSelectedOptions
                  />
                </Box>
              </Grid>

              <Grid item xs={12}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <PeopleAltIcon sx={{ mr: 2 }} />
                  <FormControl fullWidth size="small" error={!!errors.role}>
                    <InputLabel>หน้าที่</InputLabel>
                    <Select
                      value={account.role}
                      onChange={(e) =>
                        setAccount((prev) => ({
                          ...prev,
                          role: e.target.value,
                        }))
                      }
                      label="หน้าที่"
                    >
                      {roleOptions.map((r) => (
                        <MenuItem key={r} value={r}>
                          {r}
                        </MenuItem>
                      ))}
                    </Select>
                    {errors.role && (
                      <FormHelperText>{errors.role}</FormHelperText>
                    )}
                  </FormControl>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </DialogContent>

        <DialogActions sx={{ mb: 2, mr: 2 }}>
          <Button
            onClick={handleClose}
            sx={{
              width: '100px',
              border: '1px solid',
              color: '#FC3A3A',
              backgroundColor: 'transparent',
              '&:hover': { backgroundColor: 'rgba(252, 58, 58, 0.1)' },
            }}
          >
            ยกเลิก
          </Button>
          <Button
            onClick={handleEdit}
            sx={{
              width: '100px',
              border: '1px solid ',
              color: '#51D245',
              backgroundColor: 'transparent',
              '&:hover': { backgroundColor: 'rgba(81, 210, 69, 0.1)' },
            }}
          >
            บันทึก
          </Button>
        </DialogActions>
      </Dialog>

      <FinalConfirmationPopup
        open={showConfirmation}
        onClose={handleCloseConfirmation}
      />
    </>
  );
};

export default EditAccountManagementAdminEEntry;
